export default {"src":"/_next/static/media/navbar_icon.2c7d3baa.svg","height":487,"width":2000,"blurWidth":0,"blurHeight":0};